
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kb6uB", function(module, exports) {

$parcel$export(module.exports, "Marked", () => $eb09df035b210086$export$164128c95a350e30);
$parcel$export(module.exports, "marked", () => $eb09df035b210086$export$db8f131360c543a5);
/**
 * marked v15.0.12 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ // src/defaults.ts
function $eb09df035b210086$export$212bb2fc580a90a8() {
    return {
        async: false,
        breaks: false,
        extensions: null,
        gfm: true,
        hooks: null,
        pedantic: false,
        renderer: null,
        silent: false,
        tokenizer: null,
        walkTokens: null
    };
}
var $eb09df035b210086$export$ebe90cb607ad99e = $eb09df035b210086$export$212bb2fc580a90a8();
function $eb09df035b210086$var$changeDefaults(newDefaults) {
    $eb09df035b210086$export$ebe90cb607ad99e = newDefaults;
}
// src/rules.ts
var $eb09df035b210086$var$noopTest = {
    exec: ()=>null
};
function $eb09df035b210086$var$edit(regex, opt = "") {
    let source = typeof regex === "string" ? regex : regex.source;
    const obj = {
        replace: (name, val)=>{
            let valSource = typeof val === "string" ? val : val.source;
            valSource = valSource.replace($eb09df035b210086$var$other.caret, "$1");
            source = source.replace(name, valSource);
            return obj;
        },
        getRegex: ()=>{
            return new RegExp(source, opt);
        }
    };
    return obj;
}
var $eb09df035b210086$var$other = {
    codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
    outputLinkReplace: /\\([\[\]])/g,
    indentCodeCompensation: /^(\s+)(?:```)/,
    beginningSpace: /^\s+/,
    endingHash: /#$/,
    startingSpaceChar: /^ /,
    endingSpaceChar: / $/,
    nonSpaceChar: /[^ ]/,
    newLineCharGlobal: /\n/g,
    tabCharGlobal: /\t/g,
    multipleSpaceGlobal: /\s+/g,
    blankLine: /^[ \t]*$/,
    doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
    blockquoteStart: /^ {0,3}>/,
    blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
    blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
    listReplaceTabs: /^\t+/,
    listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
    listIsTask: /^\[[ xX]\] /,
    listReplaceTask: /^\[[ xX]\] +/,
    anyLine: /\n.*\n/,
    hrefBrackets: /^<(.*)>$/,
    tableDelimiter: /[:|]/,
    tableAlignChars: /^\||\| *$/g,
    tableRowBlankLine: /\n[ \t]*$/,
    tableAlignRight: /^ *-+: *$/,
    tableAlignCenter: /^ *:-+: *$/,
    tableAlignLeft: /^ *:-+ *$/,
    startATag: /^<a /i,
    endATag: /^<\/a>/i,
    startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
    endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
    startAngleBracket: /^</,
    endAngleBracket: />$/,
    pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
    unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
    escapeTest: /[&<>"']/,
    escapeReplace: /[&<>"']/g,
    escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
    escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
    unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
    caret: /(^|[^\[])\^/g,
    percentDecode: /%25/g,
    findPipe: /\|/g,
    splitPipe: / \|/,
    slashPipe: /\\\|/g,
    carriageReturn: /\r\n|\r/g,
    spaceLine: /^ +$/gm,
    notSpaceStart: /^\S*/,
    endingNewline: /\n$/,
    listItemRegex: (bull)=>new RegExp(`^( {0,3}${bull})((?:[	 ][^\\n]*)?(?:\\n|$))`),
    nextBulletRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
    hrRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
    fencesBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`),
    headingBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`),
    htmlBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, "i")
};
var $eb09df035b210086$var$newline = /^(?:[ \t]*(?:\n|$))+/;
var $eb09df035b210086$var$blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
var $eb09df035b210086$var$fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
var $eb09df035b210086$var$hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
var $eb09df035b210086$var$heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
var $eb09df035b210086$var$bullet = /(?:[*+-]|\d{1,9}[.)])/;
var $eb09df035b210086$var$lheadingCore = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/;
var $eb09df035b210086$var$lheading = $eb09df035b210086$var$edit($eb09df035b210086$var$lheadingCore).replace(/bull/g, $eb09df035b210086$var$bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex();
var $eb09df035b210086$var$lheadingGfm = $eb09df035b210086$var$edit($eb09df035b210086$var$lheadingCore).replace(/bull/g, $eb09df035b210086$var$bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex();
var $eb09df035b210086$var$_paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
var $eb09df035b210086$var$blockText = /^[^\n]+/;
var $eb09df035b210086$var$_blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
var $eb09df035b210086$var$def = $eb09df035b210086$var$edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", $eb09df035b210086$var$_blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
var $eb09df035b210086$var$list = $eb09df035b210086$var$edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, $eb09df035b210086$var$bullet).getRegex();
var $eb09df035b210086$var$_tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
var $eb09df035b210086$var$_comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
var $eb09df035b210086$var$html = $eb09df035b210086$var$edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", $eb09df035b210086$var$_comment).replace("tag", $eb09df035b210086$var$_tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
var $eb09df035b210086$var$paragraph = $eb09df035b210086$var$edit($eb09df035b210086$var$_paragraph).replace("hr", $eb09df035b210086$var$hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $eb09df035b210086$var$_tag).getRegex();
var $eb09df035b210086$var$blockquote = $eb09df035b210086$var$edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", $eb09df035b210086$var$paragraph).getRegex();
var $eb09df035b210086$var$blockNormal = {
    blockquote: $eb09df035b210086$var$blockquote,
    code: $eb09df035b210086$var$blockCode,
    def: $eb09df035b210086$var$def,
    fences: $eb09df035b210086$var$fences,
    heading: $eb09df035b210086$var$heading,
    hr: $eb09df035b210086$var$hr,
    html: $eb09df035b210086$var$html,
    lheading: $eb09df035b210086$var$lheading,
    list: $eb09df035b210086$var$list,
    newline: $eb09df035b210086$var$newline,
    paragraph: $eb09df035b210086$var$paragraph,
    table: $eb09df035b210086$var$noopTest,
    text: $eb09df035b210086$var$blockText
};
var $eb09df035b210086$var$gfmTable = $eb09df035b210086$var$edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", $eb09df035b210086$var$hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $eb09df035b210086$var$_tag).getRegex();
var $eb09df035b210086$var$blockGfm = {
    ...$eb09df035b210086$var$blockNormal,
    lheading: $eb09df035b210086$var$lheadingGfm,
    table: $eb09df035b210086$var$gfmTable,
    paragraph: $eb09df035b210086$var$edit($eb09df035b210086$var$_paragraph).replace("hr", $eb09df035b210086$var$hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", $eb09df035b210086$var$gfmTable).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $eb09df035b210086$var$_tag).getRegex()
};
var $eb09df035b210086$var$blockPedantic = {
    ...$eb09df035b210086$var$blockNormal,
    html: $eb09df035b210086$var$edit(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", $eb09df035b210086$var$_comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: $eb09df035b210086$var$noopTest,
    // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: $eb09df035b210086$var$edit($eb09df035b210086$var$_paragraph).replace("hr", $eb09df035b210086$var$hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", $eb09df035b210086$var$lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
};
var $eb09df035b210086$var$escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
var $eb09df035b210086$var$inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
var $eb09df035b210086$var$br = /^( {2,}|\\)\n(?!\s*$)/;
var $eb09df035b210086$var$inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
var $eb09df035b210086$var$_punctuation = /[\p{P}\p{S}]/u;
var $eb09df035b210086$var$_punctuationOrSpace = /[\s\p{P}\p{S}]/u;
var $eb09df035b210086$var$_notPunctuationOrSpace = /[^\s\p{P}\p{S}]/u;
var $eb09df035b210086$var$punctuation = $eb09df035b210086$var$edit(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, $eb09df035b210086$var$_punctuationOrSpace).getRegex();
var $eb09df035b210086$var$_punctuationGfmStrongEm = /(?!~)[\p{P}\p{S}]/u;
var $eb09df035b210086$var$_punctuationOrSpaceGfmStrongEm = /(?!~)[\s\p{P}\p{S}]/u;
var $eb09df035b210086$var$_notPunctuationOrSpaceGfmStrongEm = /(?:[^\s\p{P}\p{S}]|~)/u;
var $eb09df035b210086$var$blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
var $eb09df035b210086$var$emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
var $eb09df035b210086$var$emStrongLDelim = $eb09df035b210086$var$edit($eb09df035b210086$var$emStrongLDelimCore, "u").replace(/punct/g, $eb09df035b210086$var$_punctuation).getRegex();
var $eb09df035b210086$var$emStrongLDelimGfm = $eb09df035b210086$var$edit($eb09df035b210086$var$emStrongLDelimCore, "u").replace(/punct/g, $eb09df035b210086$var$_punctuationGfmStrongEm).getRegex();
var $eb09df035b210086$var$emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)";
var $eb09df035b210086$var$emStrongRDelimAst = $eb09df035b210086$var$edit($eb09df035b210086$var$emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, $eb09df035b210086$var$_notPunctuationOrSpace).replace(/punctSpace/g, $eb09df035b210086$var$_punctuationOrSpace).replace(/punct/g, $eb09df035b210086$var$_punctuation).getRegex();
var $eb09df035b210086$var$emStrongRDelimAstGfm = $eb09df035b210086$var$edit($eb09df035b210086$var$emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, $eb09df035b210086$var$_notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, $eb09df035b210086$var$_punctuationOrSpaceGfmStrongEm).replace(/punct/g, $eb09df035b210086$var$_punctuationGfmStrongEm).getRegex();
var $eb09df035b210086$var$emStrongRDelimUnd = $eb09df035b210086$var$edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, $eb09df035b210086$var$_notPunctuationOrSpace).replace(/punctSpace/g, $eb09df035b210086$var$_punctuationOrSpace).replace(/punct/g, $eb09df035b210086$var$_punctuation).getRegex();
var $eb09df035b210086$var$anyPunctuation = $eb09df035b210086$var$edit(/\\(punct)/, "gu").replace(/punct/g, $eb09df035b210086$var$_punctuation).getRegex();
var $eb09df035b210086$var$autolink = $eb09df035b210086$var$edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
var $eb09df035b210086$var$_inlineComment = $eb09df035b210086$var$edit($eb09df035b210086$var$_comment).replace("(?:-->|$)", "-->").getRegex();
var $eb09df035b210086$var$tag = $eb09df035b210086$var$edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", $eb09df035b210086$var$_inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
var $eb09df035b210086$var$_inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
var $eb09df035b210086$var$link = $eb09df035b210086$var$edit(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", $eb09df035b210086$var$_inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
var $eb09df035b210086$var$reflink = $eb09df035b210086$var$edit(/^!?\[(label)\]\[(ref)\]/).replace("label", $eb09df035b210086$var$_inlineLabel).replace("ref", $eb09df035b210086$var$_blockLabel).getRegex();
var $eb09df035b210086$var$nolink = $eb09df035b210086$var$edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", $eb09df035b210086$var$_blockLabel).getRegex();
var $eb09df035b210086$var$reflinkSearch = $eb09df035b210086$var$edit("reflink|nolink(?!\\()", "g").replace("reflink", $eb09df035b210086$var$reflink).replace("nolink", $eb09df035b210086$var$nolink).getRegex();
var $eb09df035b210086$var$inlineNormal = {
    _backpedal: $eb09df035b210086$var$noopTest,
    anyPunctuation: // only used for GFM url
    $eb09df035b210086$var$anyPunctuation,
    autolink: $eb09df035b210086$var$autolink,
    blockSkip: $eb09df035b210086$var$blockSkip,
    br: $eb09df035b210086$var$br,
    code: $eb09df035b210086$var$inlineCode,
    del: $eb09df035b210086$var$noopTest,
    emStrongLDelim: $eb09df035b210086$var$emStrongLDelim,
    emStrongRDelimAst: $eb09df035b210086$var$emStrongRDelimAst,
    emStrongRDelimUnd: $eb09df035b210086$var$emStrongRDelimUnd,
    escape: $eb09df035b210086$var$escape,
    link: $eb09df035b210086$var$link,
    nolink: $eb09df035b210086$var$nolink,
    punctuation: $eb09df035b210086$var$punctuation,
    reflink: $eb09df035b210086$var$reflink,
    reflinkSearch: $eb09df035b210086$var$reflinkSearch,
    tag: $eb09df035b210086$var$tag,
    text: $eb09df035b210086$var$inlineText,
    url: $eb09df035b210086$var$noopTest
};
var $eb09df035b210086$var$inlinePedantic = {
    ...$eb09df035b210086$var$inlineNormal,
    link: $eb09df035b210086$var$edit(/^!?\[(label)\]\((.*?)\)/).replace("label", $eb09df035b210086$var$_inlineLabel).getRegex(),
    reflink: $eb09df035b210086$var$edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", $eb09df035b210086$var$_inlineLabel).getRegex()
};
var $eb09df035b210086$var$inlineGfm = {
    ...$eb09df035b210086$var$inlineNormal,
    emStrongRDelimAst: $eb09df035b210086$var$emStrongRDelimAstGfm,
    emStrongLDelim: $eb09df035b210086$var$emStrongLDelimGfm,
    url: $eb09df035b210086$var$edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
var $eb09df035b210086$var$inlineBreaks = {
    ...$eb09df035b210086$var$inlineGfm,
    br: $eb09df035b210086$var$edit($eb09df035b210086$var$br).replace("{2,}", "*").getRegex(),
    text: $eb09df035b210086$var$edit($eb09df035b210086$var$inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
var $eb09df035b210086$var$block = {
    normal: $eb09df035b210086$var$blockNormal,
    gfm: $eb09df035b210086$var$blockGfm,
    pedantic: $eb09df035b210086$var$blockPedantic
};
var $eb09df035b210086$var$inline = {
    normal: $eb09df035b210086$var$inlineNormal,
    gfm: $eb09df035b210086$var$inlineGfm,
    breaks: $eb09df035b210086$var$inlineBreaks,
    pedantic: $eb09df035b210086$var$inlinePedantic
};
// src/helpers.ts
var $eb09df035b210086$var$escapeReplacements = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
var $eb09df035b210086$var$getEscapeReplacement = (ch)=>$eb09df035b210086$var$escapeReplacements[ch];
function $eb09df035b210086$var$escape2(html2, encode) {
    if (encode) {
        if ($eb09df035b210086$var$other.escapeTest.test(html2)) return html2.replace($eb09df035b210086$var$other.escapeReplace, $eb09df035b210086$var$getEscapeReplacement);
    } else {
        if ($eb09df035b210086$var$other.escapeTestNoEncode.test(html2)) return html2.replace($eb09df035b210086$var$other.escapeReplaceNoEncode, $eb09df035b210086$var$getEscapeReplacement);
    }
    return html2;
}
function $eb09df035b210086$var$cleanUrl(href) {
    try {
        href = encodeURI(href).replace($eb09df035b210086$var$other.percentDecode, "%");
    } catch  {
        return null;
    }
    return href;
}
function $eb09df035b210086$var$splitCells(tableRow, count) {
    const row = tableRow.replace($eb09df035b210086$var$other.findPipe, (match, offset, str)=>{
        let escaped = false;
        let curr = offset;
        while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
        if (escaped) return "|";
        else return " |";
    }), cells = row.split($eb09df035b210086$var$other.splitPipe);
    let i = 0;
    if (!cells[0].trim()) cells.shift();
    if (cells.length > 0 && !cells.at(-1)?.trim()) cells.pop();
    if (count) {
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push("");
    }
    for(; i < cells.length; i++)cells[i] = cells[i].trim().replace($eb09df035b210086$var$other.slashPipe, "|");
    return cells;
}
function $eb09df035b210086$var$rtrim(str, c, invert) {
    const l = str.length;
    if (l === 0) return "";
    let suffLen = 0;
    while(suffLen < l){
        const currChar = str.charAt(l - suffLen - 1);
        if (currChar === c && !invert) suffLen++;
        else if (currChar !== c && invert) suffLen++;
        else break;
    }
    return str.slice(0, l - suffLen);
}
function $eb09df035b210086$var$findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) return -1;
    let level = 0;
    for(let i = 0; i < str.length; i++){
        if (str[i] === "\\") i++;
        else if (str[i] === b[0]) level++;
        else if (str[i] === b[1]) {
            level--;
            if (level < 0) return i;
        }
    }
    if (level > 0) return -2;
    return -1;
}
// src/Tokenizer.ts
function $eb09df035b210086$var$outputLink(cap, link2, raw, lexer2, rules) {
    const href = link2.href;
    const title = link2.title || null;
    const text = cap[1].replace(rules.other.outputLinkReplace, "$1");
    lexer2.state.inLink = true;
    const token = {
        type: cap[0].charAt(0) === "!" ? "image" : "link",
        raw: raw,
        href: href,
        title: title,
        text: text,
        tokens: lexer2.inlineTokens(text)
    };
    lexer2.state.inLink = false;
    return token;
}
function $eb09df035b210086$var$indentCodeCompensation(raw, text, rules) {
    const matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
    if (matchIndentToCode === null) return text;
    const indentToCode = matchIndentToCode[1];
    return text.split("\n").map((node)=>{
        const matchIndentInNode = node.match(rules.other.beginningSpace);
        if (matchIndentInNode === null) return node;
        const [indentInNode] = matchIndentInNode;
        if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
        return node;
    }).join("\n");
}
var $eb09df035b210086$export$55e8b082af4aa63e = class {
    options;
    rules;
    // set by the lexer
    lexer;
    // set by the lexer
    constructor(options2){
        this.options = options2 || $eb09df035b210086$export$ebe90cb607ad99e;
    }
    space(src) {
        const cap = this.rules.block.newline.exec(src);
        if (cap && cap[0].length > 0) return {
            type: "space",
            raw: cap[0]
        };
    }
    code(src) {
        const cap = this.rules.block.code.exec(src);
        if (cap) {
            const text = cap[0].replace(this.rules.other.codeRemoveIndent, "");
            return {
                type: "code",
                raw: cap[0],
                codeBlockStyle: "indented",
                text: !this.options.pedantic ? $eb09df035b210086$var$rtrim(text, "\n") : text
            };
        }
    }
    fences(src) {
        const cap = this.rules.block.fences.exec(src);
        if (cap) {
            const raw = cap[0];
            const text = $eb09df035b210086$var$indentCodeCompensation(raw, cap[3] || "", this.rules);
            return {
                type: "code",
                raw: raw,
                lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
                text: text
            };
        }
    }
    heading(src) {
        const cap = this.rules.block.heading.exec(src);
        if (cap) {
            let text = cap[2].trim();
            if (this.rules.other.endingHash.test(text)) {
                const trimmed = $eb09df035b210086$var$rtrim(text, "#");
                if (this.options.pedantic) text = trimmed.trim();
                else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) text = trimmed.trim();
            }
            return {
                type: "heading",
                raw: cap[0],
                depth: cap[1].length,
                text: text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    hr(src) {
        const cap = this.rules.block.hr.exec(src);
        if (cap) return {
            type: "hr",
            raw: $eb09df035b210086$var$rtrim(cap[0], "\n")
        };
    }
    blockquote(src) {
        const cap = this.rules.block.blockquote.exec(src);
        if (cap) {
            let lines = $eb09df035b210086$var$rtrim(cap[0], "\n").split("\n");
            let raw = "";
            let text = "";
            const tokens = [];
            while(lines.length > 0){
                let inBlockquote = false;
                const currentLines = [];
                let i;
                for(i = 0; i < lines.length; i++){
                    if (this.rules.other.blockquoteStart.test(lines[i])) {
                        currentLines.push(lines[i]);
                        inBlockquote = true;
                    } else if (!inBlockquote) currentLines.push(lines[i]);
                    else break;
                }
                lines = lines.slice(i);
                const currentRaw = currentLines.join("\n");
                const currentText = currentRaw.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
                raw = raw ? `${raw}
${currentRaw}` : currentRaw;
                text = text ? `${text}
${currentText}` : currentText;
                const top = this.lexer.state.top;
                this.lexer.state.top = true;
                this.lexer.blockTokens(currentText, tokens, true);
                this.lexer.state.top = top;
                if (lines.length === 0) break;
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "code") break;
                else if (lastToken?.type === "blockquote") {
                    const oldToken = lastToken;
                    const newText = oldToken.raw + "\n" + lines.join("\n");
                    const newToken = this.blockquote(newText);
                    tokens[tokens.length - 1] = newToken;
                    raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                    text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                    break;
                } else if (lastToken?.type === "list") {
                    const oldToken = lastToken;
                    const newText = oldToken.raw + "\n" + lines.join("\n");
                    const newToken = this.list(newText);
                    tokens[tokens.length - 1] = newToken;
                    raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                    text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                    lines = newText.substring(tokens.at(-1).raw.length).split("\n");
                    continue;
                }
            }
            return {
                type: "blockquote",
                raw: raw,
                tokens: tokens,
                text: text
            };
        }
    }
    list(src) {
        let cap = this.rules.block.list.exec(src);
        if (cap) {
            let bull = cap[1].trim();
            const isordered = bull.length > 1;
            const list2 = {
                type: "list",
                raw: "",
                ordered: isordered,
                start: isordered ? +bull.slice(0, -1) : "",
                loose: false,
                items: []
            };
            bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
            if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
            const itemRegex = this.rules.other.listItemRegex(bull);
            let endsWithBlankLine = false;
            while(src){
                let endEarly = false;
                let raw = "";
                let itemContents = "";
                if (!(cap = itemRegex.exec(src))) break;
                if (this.rules.block.hr.test(src)) break;
                raw = cap[0];
                src = src.substring(raw.length);
                let line = cap[2].split("\n", 1)[0].replace(this.rules.other.listReplaceTabs, (t)=>" ".repeat(3 * t.length));
                let nextLine = src.split("\n", 1)[0];
                let blankLine = !line.trim();
                let indent = 0;
                if (this.options.pedantic) {
                    indent = 2;
                    itemContents = line.trimStart();
                } else if (blankLine) indent = cap[1].length + 1;
                else {
                    indent = cap[2].search(this.rules.other.nonSpaceChar);
                    indent = indent > 4 ? 1 : indent;
                    itemContents = line.slice(indent);
                    indent += cap[1].length;
                }
                if (blankLine && this.rules.other.blankLine.test(nextLine)) {
                    raw += nextLine + "\n";
                    src = src.substring(nextLine.length + 1);
                    endEarly = true;
                }
                if (!endEarly) {
                    const nextBulletRegex = this.rules.other.nextBulletRegex(indent);
                    const hrRegex = this.rules.other.hrRegex(indent);
                    const fencesBeginRegex = this.rules.other.fencesBeginRegex(indent);
                    const headingBeginRegex = this.rules.other.headingBeginRegex(indent);
                    const htmlBeginRegex = this.rules.other.htmlBeginRegex(indent);
                    while(src){
                        const rawLine = src.split("\n", 1)[0];
                        let nextLineWithoutTabs;
                        nextLine = rawLine;
                        if (this.options.pedantic) {
                            nextLine = nextLine.replace(this.rules.other.listReplaceNesting, "  ");
                            nextLineWithoutTabs = nextLine;
                        } else nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, "    ");
                        if (fencesBeginRegex.test(nextLine)) break;
                        if (headingBeginRegex.test(nextLine)) break;
                        if (htmlBeginRegex.test(nextLine)) break;
                        if (nextBulletRegex.test(nextLine)) break;
                        if (hrRegex.test(nextLine)) break;
                        if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) itemContents += "\n" + nextLineWithoutTabs.slice(indent);
                        else {
                            if (blankLine) break;
                            if (line.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4) break;
                            if (fencesBeginRegex.test(line)) break;
                            if (headingBeginRegex.test(line)) break;
                            if (hrRegex.test(line)) break;
                            itemContents += "\n" + nextLine;
                        }
                        if (!blankLine && !nextLine.trim()) blankLine = true;
                        raw += rawLine + "\n";
                        src = src.substring(rawLine.length + 1);
                        line = nextLineWithoutTabs.slice(indent);
                    }
                }
                if (!list2.loose) {
                    if (endsWithBlankLine) list2.loose = true;
                    else if (this.rules.other.doubleBlankLine.test(raw)) endsWithBlankLine = true;
                }
                let istask = null;
                let ischecked;
                if (this.options.gfm) {
                    istask = this.rules.other.listIsTask.exec(itemContents);
                    if (istask) {
                        ischecked = istask[0] !== "[ ] ";
                        itemContents = itemContents.replace(this.rules.other.listReplaceTask, "");
                    }
                }
                list2.items.push({
                    type: "list_item",
                    raw: raw,
                    task: !!istask,
                    checked: ischecked,
                    loose: false,
                    text: itemContents,
                    tokens: []
                });
                list2.raw += raw;
            }
            const lastItem = list2.items.at(-1);
            if (lastItem) {
                lastItem.raw = lastItem.raw.trimEnd();
                lastItem.text = lastItem.text.trimEnd();
            } else return;
            list2.raw = list2.raw.trimEnd();
            for(let i = 0; i < list2.items.length; i++){
                this.lexer.state.top = false;
                list2.items[i].tokens = this.lexer.blockTokens(list2.items[i].text, []);
                if (!list2.loose) {
                    const spacers = list2.items[i].tokens.filter((t)=>t.type === "space");
                    const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>this.rules.other.anyLine.test(t.raw));
                    list2.loose = hasMultipleLineBreaks;
                }
            }
            if (list2.loose) for(let i = 0; i < list2.items.length; i++)list2.items[i].loose = true;
            return list2;
        }
    }
    html(src) {
        const cap = this.rules.block.html.exec(src);
        if (cap) {
            const token = {
                type: "html",
                block: true,
                raw: cap[0],
                pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                text: cap[0]
            };
            return token;
        }
    }
    def(src) {
        const cap = this.rules.block.def.exec(src);
        if (cap) {
            const tag2 = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " ");
            const href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
            const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
            return {
                type: "def",
                tag: tag2,
                raw: cap[0],
                href: href,
                title: title
            };
        }
    }
    table(src) {
        const cap = this.rules.block.table.exec(src);
        if (!cap) return;
        if (!this.rules.other.tableDelimiter.test(cap[2])) return;
        const headers = $eb09df035b210086$var$splitCells(cap[1]);
        const aligns = cap[2].replace(this.rules.other.tableAlignChars, "").split("|");
        const rows = cap[3]?.trim() ? cap[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [];
        const item = {
            type: "table",
            raw: cap[0],
            header: [],
            align: [],
            rows: []
        };
        if (headers.length !== aligns.length) return;
        for (const align of aligns){
            if (this.rules.other.tableAlignRight.test(align)) item.align.push("right");
            else if (this.rules.other.tableAlignCenter.test(align)) item.align.push("center");
            else if (this.rules.other.tableAlignLeft.test(align)) item.align.push("left");
            else item.align.push(null);
        }
        for(let i = 0; i < headers.length; i++)item.header.push({
            text: headers[i],
            tokens: this.lexer.inline(headers[i]),
            header: true,
            align: item.align[i]
        });
        for (const row of rows)item.rows.push($eb09df035b210086$var$splitCells(row, item.header.length).map((cell, i)=>{
            return {
                text: cell,
                tokens: this.lexer.inline(cell),
                header: false,
                align: item.align[i]
            };
        }));
        return item;
    }
    lheading(src) {
        const cap = this.rules.block.lheading.exec(src);
        if (cap) return {
            type: "heading",
            raw: cap[0],
            depth: cap[2].charAt(0) === "=" ? 1 : 2,
            text: cap[1],
            tokens: this.lexer.inline(cap[1])
        };
    }
    paragraph(src) {
        const cap = this.rules.block.paragraph.exec(src);
        if (cap) {
            const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
            return {
                type: "paragraph",
                raw: cap[0],
                text: text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    text(src) {
        const cap = this.rules.block.text.exec(src);
        if (cap) return {
            type: "text",
            raw: cap[0],
            text: cap[0],
            tokens: this.lexer.inline(cap[0])
        };
    }
    escape(src) {
        const cap = this.rules.inline.escape.exec(src);
        if (cap) return {
            type: "escape",
            raw: cap[0],
            text: cap[1]
        };
    }
    tag(src) {
        const cap = this.rules.inline.tag.exec(src);
        if (cap) {
            if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) this.lexer.state.inLink = true;
            else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) this.lexer.state.inLink = false;
            if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = true;
            else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = false;
            return {
                type: "html",
                raw: cap[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: false,
                text: cap[0]
            };
        }
    }
    link(src) {
        const cap = this.rules.inline.link.exec(src);
        if (cap) {
            const trimmedUrl = cap[2].trim();
            if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
                if (!this.rules.other.endAngleBracket.test(trimmedUrl)) return;
                const rtrimSlash = $eb09df035b210086$var$rtrim(trimmedUrl.slice(0, -1), "\\");
                if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
            } else {
                const lastParenIndex = $eb09df035b210086$var$findClosingBracket(cap[2], "()");
                if (lastParenIndex === -2) return;
                if (lastParenIndex > -1) {
                    const start = cap[0].indexOf("!") === 0 ? 5 : 4;
                    const linkLen = start + cap[1].length + lastParenIndex;
                    cap[2] = cap[2].substring(0, lastParenIndex);
                    cap[0] = cap[0].substring(0, linkLen).trim();
                    cap[3] = "";
                }
            }
            let href = cap[2];
            let title = "";
            if (this.options.pedantic) {
                const link2 = this.rules.other.pedanticHrefTitle.exec(href);
                if (link2) {
                    href = link2[1];
                    title = link2[3];
                }
            } else title = cap[3] ? cap[3].slice(1, -1) : "";
            href = href.trim();
            if (this.rules.other.startAngleBracket.test(href)) {
                if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) href = href.slice(1);
                else href = href.slice(1, -1);
            }
            return $eb09df035b210086$var$outputLink(cap, {
                href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
                title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
            }, cap[0], this.lexer, this.rules);
        }
    }
    reflink(src, links) {
        let cap;
        if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
            const linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, " ");
            const link2 = links[linkString.toLowerCase()];
            if (!link2) {
                const text = cap[0].charAt(0);
                return {
                    type: "text",
                    raw: text,
                    text: text
                };
            }
            return $eb09df035b210086$var$outputLink(cap, link2, cap[0], this.lexer, this.rules);
        }
    }
    emStrong(src, maskedSrc, prevChar = "") {
        let match = this.rules.inline.emStrongLDelim.exec(src);
        if (!match) return;
        if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
        const nextChar = match[1] || match[2] || "";
        if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
            const lLength = [
                ...match[0]
            ].length - 1;
            let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
            const endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
            endReg.lastIndex = 0;
            maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
            while((match = endReg.exec(maskedSrc)) != null){
                rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                if (!rDelim) continue;
                rLength = [
                    ...rDelim
                ].length;
                if (match[3] || match[4]) {
                    delimTotal += rLength;
                    continue;
                } else if (match[5] || match[6]) {
                    if (lLength % 3 && !((lLength + rLength) % 3)) {
                        midDelimTotal += rLength;
                        continue;
                    }
                }
                delimTotal -= rLength;
                if (delimTotal > 0) continue;
                rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                const lastCharLength = [
                    ...match[0]
                ][0].length;
                const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                if (Math.min(lLength, rLength) % 2) {
                    const text2 = raw.slice(1, -1);
                    return {
                        type: "em",
                        raw: raw,
                        text: text2,
                        tokens: this.lexer.inlineTokens(text2)
                    };
                }
                const text = raw.slice(2, -2);
                return {
                    type: "strong",
                    raw: raw,
                    text: text,
                    tokens: this.lexer.inlineTokens(text)
                };
            }
        }
    }
    codespan(src) {
        const cap = this.rules.inline.code.exec(src);
        if (cap) {
            let text = cap[2].replace(this.rules.other.newLineCharGlobal, " ");
            const hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
            const hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
            if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
            return {
                type: "codespan",
                raw: cap[0],
                text: text
            };
        }
    }
    br(src) {
        const cap = this.rules.inline.br.exec(src);
        if (cap) return {
            type: "br",
            raw: cap[0]
        };
    }
    del(src) {
        const cap = this.rules.inline.del.exec(src);
        if (cap) return {
            type: "del",
            raw: cap[0],
            text: cap[2],
            tokens: this.lexer.inlineTokens(cap[2])
        };
    }
    autolink(src) {
        const cap = this.rules.inline.autolink.exec(src);
        if (cap) {
            let text, href;
            if (cap[2] === "@") {
                text = cap[1];
                href = "mailto:" + text;
            } else {
                text = cap[1];
                href = text;
            }
            return {
                type: "link",
                raw: cap[0],
                text: text,
                href: href,
                tokens: [
                    {
                        type: "text",
                        raw: text,
                        text: text
                    }
                ]
            };
        }
    }
    url(src) {
        let cap;
        if (cap = this.rules.inline.url.exec(src)) {
            let text, href;
            if (cap[2] === "@") {
                text = cap[0];
                href = "mailto:" + text;
            } else {
                let prevCapZero;
                do {
                    prevCapZero = cap[0];
                    cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? "";
                }while (prevCapZero !== cap[0]);
                text = cap[0];
                if (cap[1] === "www.") href = "http://" + cap[0];
                else href = cap[0];
            }
            return {
                type: "link",
                raw: cap[0],
                text: text,
                href: href,
                tokens: [
                    {
                        type: "text",
                        raw: text,
                        text: text
                    }
                ]
            };
        }
    }
    inlineText(src) {
        const cap = this.rules.inline.text.exec(src);
        if (cap) {
            const escaped = this.lexer.state.inRawBlock;
            return {
                type: "text",
                raw: cap[0],
                text: cap[0],
                escaped: escaped
            };
        }
    }
};
// src/Lexer.ts
var $eb09df035b210086$export$6168dc8908a6c652 = class __Lexer {
    tokens;
    options;
    state;
    tokenizer;
    inlineQueue;
    constructor(options2){
        this.tokens = [];
        this.tokens.links = /* @__PURE__ */ Object.create(null);
        this.options = options2 || $eb09df035b210086$export$ebe90cb607ad99e;
        this.options.tokenizer = this.options.tokenizer || new $eb09df035b210086$export$55e8b082af4aa63e();
        this.tokenizer = this.options.tokenizer;
        this.tokenizer.options = this.options;
        this.tokenizer.lexer = this;
        this.inlineQueue = [];
        this.state = {
            inLink: false,
            inRawBlock: false,
            top: true
        };
        const rules = {
            other: $eb09df035b210086$var$other,
            block: $eb09df035b210086$var$block.normal,
            inline: $eb09df035b210086$var$inline.normal
        };
        if (this.options.pedantic) {
            rules.block = $eb09df035b210086$var$block.pedantic;
            rules.inline = $eb09df035b210086$var$inline.pedantic;
        } else if (this.options.gfm) {
            rules.block = $eb09df035b210086$var$block.gfm;
            if (this.options.breaks) rules.inline = $eb09df035b210086$var$inline.breaks;
            else rules.inline = $eb09df035b210086$var$inline.gfm;
        }
        this.tokenizer.rules = rules;
    }
    /**
   * Expose Rules
   */ static get rules() {
        return {
            block: $eb09df035b210086$var$block,
            inline: $eb09df035b210086$var$inline
        };
    }
    /**
   * Static Lex Method
   */ static lex(src, options2) {
        const lexer2 = new __Lexer(options2);
        return lexer2.lex(src);
    }
    /**
   * Static Lex Inline Method
   */ static lexInline(src, options2) {
        const lexer2 = new __Lexer(options2);
        return lexer2.inlineTokens(src);
    }
    /**
   * Preprocessing
   */ lex(src) {
        src = src.replace($eb09df035b210086$var$other.carriageReturn, "\n");
        this.blockTokens(src, this.tokens);
        for(let i = 0; i < this.inlineQueue.length; i++){
            const next = this.inlineQueue[i];
            this.inlineTokens(next.src, next.tokens);
        }
        this.inlineQueue = [];
        return this.tokens;
    }
    blockTokens(src, tokens = [], lastParagraphClipped = false) {
        if (this.options.pedantic) src = src.replace($eb09df035b210086$var$other.tabCharGlobal, "    ").replace($eb09df035b210086$var$other.spaceLine, "");
        while(src){
            let token;
            if (this.options.extensions?.block?.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            if (token = this.tokenizer.space(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (token.raw.length === 1 && lastToken !== void 0) lastToken.raw += "\n";
                else tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.code(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.fences(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.heading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.hr(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.blockquote(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.list(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.html(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.def(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.raw;
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                    href: token.href,
                    title: token.title
                };
                continue;
            }
            if (token = this.tokenizer.table(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.lheading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            let cutSrc = src;
            if (this.options.extensions?.startBlock) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startBlock.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                const lastToken = tokens.at(-1);
                if (lastParagraphClipped && lastToken?.type === "paragraph") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                lastParagraphClipped = cutSrc.length !== src.length;
                src = src.substring(token.raw.length);
                continue;
            }
            if (token = this.tokenizer.text(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "text") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        this.state.top = true;
        return tokens;
    }
    inline(src, tokens = []) {
        this.inlineQueue.push({
            src: src,
            tokens: tokens
        });
        return tokens;
    }
    /**
   * Lexing/Compiling
   */ inlineTokens(src, tokens = []) {
        let maskedSrc = src;
        let match = null;
        if (this.tokens.links) {
            const links = Object.keys(this.tokens.links);
            if (links.length > 0) {
                while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
        }
        while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
        while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        let keepPrevChar = false;
        let prevChar = "";
        while(src){
            if (!keepPrevChar) prevChar = "";
            keepPrevChar = false;
            let token;
            if (this.options.extensions?.inline?.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            if (token = this.tokenizer.escape(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.tag(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.link(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (token.type === "text" && lastToken?.type === "text") {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.codespan(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.br(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.del(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.autolink(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            let cutSrc = src;
            if (this.options.extensions?.startInline) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startInline.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (token = this.tokenizer.inlineText(cutSrc)) {
                src = src.substring(token.raw.length);
                if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                keepPrevChar = true;
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "text") {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        return tokens;
    }
};
// src/Renderer.ts
var $eb09df035b210086$export$88530751e3977073 = class {
    options;
    parser;
    // set by the parser
    constructor(options2){
        this.options = options2 || $eb09df035b210086$export$ebe90cb607ad99e;
    }
    space(token) {
        return "";
    }
    code({ text: text, lang: lang, escaped: escaped }) {
        const langString = (lang || "").match($eb09df035b210086$var$other.notSpaceStart)?.[0];
        const code = text.replace($eb09df035b210086$var$other.endingNewline, "") + "\n";
        if (!langString) return "<pre><code>" + (escaped ? code : $eb09df035b210086$var$escape2(code, true)) + "</code></pre>\n";
        return '<pre><code class="language-' + $eb09df035b210086$var$escape2(langString) + '">' + (escaped ? code : $eb09df035b210086$var$escape2(code, true)) + "</code></pre>\n";
    }
    blockquote({ tokens: tokens }) {
        const body = this.parser.parse(tokens);
        return `<blockquote>
${body}</blockquote>
`;
    }
    html({ text: text }) {
        return text;
    }
    heading({ tokens: tokens, depth: depth }) {
        return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>
`;
    }
    hr(token) {
        return "<hr>\n";
    }
    list(token) {
        const ordered = token.ordered;
        const start = token.start;
        let body = "";
        for(let j = 0; j < token.items.length; j++){
            const item = token.items[j];
            body += this.listitem(item);
        }
        const type = ordered ? "ol" : "ul";
        const startAttr = ordered && start !== 1 ? ' start="' + start + '"' : "";
        return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
    }
    listitem(item) {
        let itemBody = "";
        if (item.task) {
            const checkbox = this.checkbox({
                checked: !!item.checked
            });
            if (item.loose) {
                if (item.tokens[0]?.type === "paragraph") {
                    item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                    if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
                        item.tokens[0].tokens[0].text = checkbox + " " + $eb09df035b210086$var$escape2(item.tokens[0].tokens[0].text);
                        item.tokens[0].tokens[0].escaped = true;
                    }
                } else item.tokens.unshift({
                    type: "text",
                    raw: checkbox + " ",
                    text: checkbox + " ",
                    escaped: true
                });
            } else itemBody += checkbox + " ";
        }
        itemBody += this.parser.parse(item.tokens, !!item.loose);
        return `<li>${itemBody}</li>
`;
    }
    checkbox({ checked: checked }) {
        return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
    }
    paragraph({ tokens: tokens }) {
        return `<p>${this.parser.parseInline(tokens)}</p>
`;
    }
    table(token) {
        let header = "";
        let cell = "";
        for(let j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
        header += this.tablerow({
            text: cell
        });
        let body = "";
        for(let j = 0; j < token.rows.length; j++){
            const row = token.rows[j];
            cell = "";
            for(let k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
            body += this.tablerow({
                text: cell
            });
        }
        if (body) body = `<tbody>${body}</tbody>`;
        return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
    }
    tablerow({ text: text }) {
        return `<tr>
${text}</tr>
`;
    }
    tablecell(token) {
        const content = this.parser.parseInline(token.tokens);
        const type = token.header ? "th" : "td";
        const tag2 = token.align ? `<${type} align="${token.align}">` : `<${type}>`;
        return tag2 + content + `</${type}>
`;
    }
    /**
   * span level renderer
   */ strong({ tokens: tokens }) {
        return `<strong>${this.parser.parseInline(tokens)}</strong>`;
    }
    em({ tokens: tokens }) {
        return `<em>${this.parser.parseInline(tokens)}</em>`;
    }
    codespan({ text: text }) {
        return `<code>${$eb09df035b210086$var$escape2(text, true)}</code>`;
    }
    br(token) {
        return "<br>";
    }
    del({ tokens: tokens }) {
        return `<del>${this.parser.parseInline(tokens)}</del>`;
    }
    link({ href: href, title: title, tokens: tokens }) {
        const text = this.parser.parseInline(tokens);
        const cleanHref = $eb09df035b210086$var$cleanUrl(href);
        if (cleanHref === null) return text;
        href = cleanHref;
        let out = '<a href="' + href + '"';
        if (title) out += ' title="' + $eb09df035b210086$var$escape2(title) + '"';
        out += ">" + text + "</a>";
        return out;
    }
    image({ href: href, title: title, text: text, tokens: tokens }) {
        if (tokens) text = this.parser.parseInline(tokens, this.parser.textRenderer);
        const cleanHref = $eb09df035b210086$var$cleanUrl(href);
        if (cleanHref === null) return $eb09df035b210086$var$escape2(text);
        href = cleanHref;
        let out = `<img src="${href}" alt="${text}"`;
        if (title) out += ` title="${$eb09df035b210086$var$escape2(title)}"`;
        out += ">";
        return out;
    }
    text(token) {
        return "tokens" in token && token.tokens ? this.parser.parseInline(token.tokens) : "escaped" in token && token.escaped ? token.text : $eb09df035b210086$var$escape2(token.text);
    }
};
// src/TextRenderer.ts
var $eb09df035b210086$export$75ebcd2c8ed5b901 = class {
    // no need for block level renderers
    strong({ text: text }) {
        return text;
    }
    em({ text: text }) {
        return text;
    }
    codespan({ text: text }) {
        return text;
    }
    del({ text: text }) {
        return text;
    }
    html({ text: text }) {
        return text;
    }
    text({ text: text }) {
        return text;
    }
    link({ text: text }) {
        return "" + text;
    }
    image({ text: text }) {
        return "" + text;
    }
    br() {
        return "";
    }
};
// src/Parser.ts
var $eb09df035b210086$export$7acfa6ed01010e37 = class __Parser {
    options;
    renderer;
    textRenderer;
    constructor(options2){
        this.options = options2 || $eb09df035b210086$export$ebe90cb607ad99e;
        this.options.renderer = this.options.renderer || new $eb09df035b210086$export$88530751e3977073();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.renderer.parser = this;
        this.textRenderer = new $eb09df035b210086$export$75ebcd2c8ed5b901();
    }
    /**
   * Static Parse Method
   */ static parse(tokens, options2) {
        const parser2 = new __Parser(options2);
        return parser2.parse(tokens);
    }
    /**
   * Static Parse Inline Method
   */ static parseInline(tokens, options2) {
        const parser2 = new __Parser(options2);
        return parser2.parseInline(tokens);
    }
    /**
   * Parse Loop
   */ parse(tokens, top = true) {
        let out = "";
        for(let i = 0; i < tokens.length; i++){
            const anyToken = tokens[i];
            if (this.options.extensions?.renderers?.[anyToken.type]) {
                const genericToken = anyToken;
                const ret = this.options.extensions.renderers[genericToken.type].call({
                    parser: this
                }, genericToken);
                if (ret !== false || ![
                    "space",
                    "hr",
                    "heading",
                    "code",
                    "table",
                    "blockquote",
                    "list",
                    "html",
                    "paragraph",
                    "text"
                ].includes(genericToken.type)) {
                    out += ret || "";
                    continue;
                }
            }
            const token = anyToken;
            switch(token.type){
                case "space":
                    out += this.renderer.space(token);
                    continue;
                case "hr":
                    out += this.renderer.hr(token);
                    continue;
                case "heading":
                    out += this.renderer.heading(token);
                    continue;
                case "code":
                    out += this.renderer.code(token);
                    continue;
                case "table":
                    out += this.renderer.table(token);
                    continue;
                case "blockquote":
                    out += this.renderer.blockquote(token);
                    continue;
                case "list":
                    out += this.renderer.list(token);
                    continue;
                case "html":
                    out += this.renderer.html(token);
                    continue;
                case "paragraph":
                    out += this.renderer.paragraph(token);
                    continue;
                case "text":
                    {
                        let textToken = token;
                        let body = this.renderer.text(textToken);
                        while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                            textToken = tokens[++i];
                            body += "\n" + this.renderer.text(textToken);
                        }
                        if (top) out += this.renderer.paragraph({
                            type: "paragraph",
                            raw: body,
                            text: body,
                            tokens: [
                                {
                                    type: "text",
                                    raw: body,
                                    text: body,
                                    escaped: true
                                }
                            ]
                        });
                        else out += body;
                        continue;
                    }
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return "";
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
    /**
   * Parse Inline Tokens
   */ parseInline(tokens, renderer = this.renderer) {
        let out = "";
        for(let i = 0; i < tokens.length; i++){
            const anyToken = tokens[i];
            if (this.options.extensions?.renderers?.[anyToken.type]) {
                const ret = this.options.extensions.renderers[anyToken.type].call({
                    parser: this
                }, anyToken);
                if (ret !== false || ![
                    "escape",
                    "html",
                    "link",
                    "image",
                    "strong",
                    "em",
                    "codespan",
                    "br",
                    "del",
                    "text"
                ].includes(anyToken.type)) {
                    out += ret || "";
                    continue;
                }
            }
            const token = anyToken;
            switch(token.type){
                case "escape":
                    out += renderer.text(token);
                    break;
                case "html":
                    out += renderer.html(token);
                    break;
                case "link":
                    out += renderer.link(token);
                    break;
                case "image":
                    out += renderer.image(token);
                    break;
                case "strong":
                    out += renderer.strong(token);
                    break;
                case "em":
                    out += renderer.em(token);
                    break;
                case "codespan":
                    out += renderer.codespan(token);
                    break;
                case "br":
                    out += renderer.br(token);
                    break;
                case "del":
                    out += renderer.del(token);
                    break;
                case "text":
                    out += renderer.text(token);
                    break;
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return "";
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
};
// src/Hooks.ts
var $eb09df035b210086$export$5fbefe39e79899a6 = class {
    options;
    block;
    constructor(options2){
        this.options = options2 || $eb09df035b210086$export$ebe90cb607ad99e;
    }
    static passThroughHooks = /* @__PURE__ */ new Set([
        "preprocess",
        "postprocess",
        "processAllTokens"
    ]);
    /**
   * Process markdown before marked
   */ preprocess(markdown) {
        return markdown;
    }
    /**
   * Process HTML after marked is finished
   */ postprocess(html2) {
        return html2;
    }
    /**
   * Process all tokens before walk tokens
   */ processAllTokens(tokens) {
        return tokens;
    }
    /**
   * Provide function to tokenize markdown
   */ provideLexer() {
        return this.block ? $eb09df035b210086$export$6168dc8908a6c652.lex : $eb09df035b210086$export$6168dc8908a6c652.lexInline;
    }
    /**
   * Provide function to parse tokens
   */ provideParser() {
        return this.block ? $eb09df035b210086$export$7acfa6ed01010e37.parse : $eb09df035b210086$export$7acfa6ed01010e37.parseInline;
    }
};
// src/Instance.ts
var $eb09df035b210086$export$164128c95a350e30 = class {
    defaults = $eb09df035b210086$export$212bb2fc580a90a8();
    options = this.setOptions;
    parse = this.parseMarkdown(true);
    parseInline = this.parseMarkdown(false);
    Parser = $eb09df035b210086$export$7acfa6ed01010e37;
    Renderer = $eb09df035b210086$export$88530751e3977073;
    TextRenderer = $eb09df035b210086$export$75ebcd2c8ed5b901;
    Lexer = $eb09df035b210086$export$6168dc8908a6c652;
    Tokenizer = $eb09df035b210086$export$55e8b082af4aa63e;
    Hooks = $eb09df035b210086$export$5fbefe39e79899a6;
    constructor(...args){
        this.use(...args);
    }
    /**
   * Run callback for every token
   */ walkTokens(tokens, callback) {
        let values = [];
        for (const token of tokens){
            values = values.concat(callback.call(this, token));
            switch(token.type){
                case "table":
                    {
                        const tableToken = token;
                        for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                        for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                        break;
                    }
                case "list":
                    {
                        const listToken = token;
                        values = values.concat(this.walkTokens(listToken.items, callback));
                        break;
                    }
                default:
                    {
                        const genericToken = token;
                        if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                            const tokens2 = genericToken[childTokens].flat(Infinity);
                            values = values.concat(this.walkTokens(tokens2, callback));
                        });
                        else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                    }
            }
        }
        return values;
    }
    use(...args) {
        const extensions = this.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        args.forEach((pack)=>{
            const opts = {
                ...pack
            };
            opts.async = this.defaults.async || opts.async || false;
            if (pack.extensions) {
                pack.extensions.forEach((ext)=>{
                    if (!ext.name) throw new Error("extension name required");
                    if ("renderer" in ext) {
                        const prevRenderer = extensions.renderers[ext.name];
                        if (prevRenderer) extensions.renderers[ext.name] = function(...args2) {
                            let ret = ext.renderer.apply(this, args2);
                            if (ret === false) ret = prevRenderer.apply(this, args2);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if ("tokenizer" in ext) {
                        if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        const extLevel = extensions[ext.level];
                        if (extLevel) extLevel.unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            if (ext.level === "block") {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === "inline") {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                });
                opts.extensions = extensions;
            }
            if (pack.renderer) {
                const renderer = this.defaults.renderer || new $eb09df035b210086$export$88530751e3977073(this.defaults);
                for(const prop in pack.renderer){
                    if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                    if ([
                        "options",
                        "parser"
                    ].includes(prop)) continue;
                    const rendererProp = prop;
                    const rendererFunc = pack.renderer[rendererProp];
                    const prevRenderer = renderer[rendererProp];
                    renderer[rendererProp] = (...args2)=>{
                        let ret = rendererFunc.apply(renderer, args2);
                        if (ret === false) ret = prevRenderer.apply(renderer, args2);
                        return ret || "";
                    };
                }
                opts.renderer = renderer;
            }
            if (pack.tokenizer) {
                const tokenizer = this.defaults.tokenizer || new $eb09df035b210086$export$55e8b082af4aa63e(this.defaults);
                for(const prop in pack.tokenizer){
                    if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
                    if ([
                        "options",
                        "rules",
                        "lexer"
                    ].includes(prop)) continue;
                    const tokenizerProp = prop;
                    const tokenizerFunc = pack.tokenizer[tokenizerProp];
                    const prevTokenizer = tokenizer[tokenizerProp];
                    tokenizer[tokenizerProp] = (...args2)=>{
                        let ret = tokenizerFunc.apply(tokenizer, args2);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args2);
                        return ret;
                    };
                }
                opts.tokenizer = tokenizer;
            }
            if (pack.hooks) {
                const hooks = this.defaults.hooks || new $eb09df035b210086$export$5fbefe39e79899a6();
                for(const prop in pack.hooks){
                    if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
                    if ([
                        "options",
                        "block"
                    ].includes(prop)) continue;
                    const hooksProp = prop;
                    const hooksFunc = pack.hooks[hooksProp];
                    const prevHook = hooks[hooksProp];
                    if ($eb09df035b210086$export$5fbefe39e79899a6.passThroughHooks.has(prop)) hooks[hooksProp] = (arg)=>{
                        if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret2)=>{
                            return prevHook.call(hooks, ret2);
                        });
                        const ret = hooksFunc.call(hooks, arg);
                        return prevHook.call(hooks, ret);
                    };
                    else hooks[hooksProp] = (...args2)=>{
                        let ret = hooksFunc.apply(hooks, args2);
                        if (ret === false) ret = prevHook.apply(hooks, args2);
                        return ret;
                    };
                }
                opts.hooks = hooks;
            }
            if (pack.walkTokens) {
                const walkTokens2 = this.defaults.walkTokens;
                const packWalktokens = pack.walkTokens;
                opts.walkTokens = function(token) {
                    let values = [];
                    values.push(packWalktokens.call(this, token));
                    if (walkTokens2) values = values.concat(walkTokens2.call(this, token));
                    return values;
                };
            }
            this.defaults = {
                ...this.defaults,
                ...opts
            };
        });
        return this;
    }
    setOptions(opt) {
        this.defaults = {
            ...this.defaults,
            ...opt
        };
        return this;
    }
    lexer(src, options2) {
        return $eb09df035b210086$export$6168dc8908a6c652.lex(src, options2 ?? this.defaults);
    }
    parser(tokens, options2) {
        return $eb09df035b210086$export$7acfa6ed01010e37.parse(tokens, options2 ?? this.defaults);
    }
    parseMarkdown(blockType) {
        const parse2 = (src, options2)=>{
            const origOpt = {
                ...options2
            };
            const opt = {
                ...this.defaults,
                ...origOpt
            };
            const throwError = this.onError(!!opt.silent, !!opt.async);
            if (this.defaults.async === true && origOpt.async === false) return throwError(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
            if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
            if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
            if (opt.hooks) {
                opt.hooks.options = opt;
                opt.hooks.block = blockType;
            }
            const lexer2 = opt.hooks ? opt.hooks.provideLexer() : blockType ? $eb09df035b210086$export$6168dc8908a6c652.lex : $eb09df035b210086$export$6168dc8908a6c652.lexInline;
            const parser2 = opt.hooks ? opt.hooks.provideParser() : blockType ? $eb09df035b210086$export$7acfa6ed01010e37.parse : $eb09df035b210086$export$7acfa6ed01010e37.parseInline;
            if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src2)=>lexer2(src2, opt)).then((tokens)=>opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser2(tokens, opt)).then((html2)=>opt.hooks ? opt.hooks.postprocess(html2) : html2).catch(throwError);
            try {
                if (opt.hooks) src = opt.hooks.preprocess(src);
                let tokens = lexer2(src, opt);
                if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                let html2 = parser2(tokens, opt);
                if (opt.hooks) html2 = opt.hooks.postprocess(html2);
                return html2;
            } catch (e) {
                return throwError(e);
            }
        };
        return parse2;
    }
    onError(silent, async) {
        return (e)=>{
            e.message += "\nPlease report this to https://github.com/markedjs/marked.";
            if (silent) {
                const msg = "<p>An error occurred:</p><pre>" + $eb09df035b210086$var$escape2(e.message + "", true) + "</pre>";
                if (async) return Promise.resolve(msg);
                return msg;
            }
            if (async) return Promise.reject(e);
            throw e;
        };
    }
};
// src/marked.ts
var $eb09df035b210086$var$markedInstance = new $eb09df035b210086$export$164128c95a350e30();
function $eb09df035b210086$export$db8f131360c543a5(src, opt) {
    return $eb09df035b210086$var$markedInstance.parse(src, opt);
}
$eb09df035b210086$export$db8f131360c543a5.options = $eb09df035b210086$export$db8f131360c543a5.setOptions = function(options2) {
    $eb09df035b210086$var$markedInstance.setOptions(options2);
    $eb09df035b210086$export$db8f131360c543a5.defaults = $eb09df035b210086$var$markedInstance.defaults;
    $eb09df035b210086$var$changeDefaults($eb09df035b210086$export$db8f131360c543a5.defaults);
    return $eb09df035b210086$export$db8f131360c543a5;
};
$eb09df035b210086$export$db8f131360c543a5.getDefaults = $eb09df035b210086$export$212bb2fc580a90a8;
$eb09df035b210086$export$db8f131360c543a5.defaults = $eb09df035b210086$export$ebe90cb607ad99e;
$eb09df035b210086$export$db8f131360c543a5.use = function(...args) {
    $eb09df035b210086$var$markedInstance.use(...args);
    $eb09df035b210086$export$db8f131360c543a5.defaults = $eb09df035b210086$var$markedInstance.defaults;
    $eb09df035b210086$var$changeDefaults($eb09df035b210086$export$db8f131360c543a5.defaults);
    return $eb09df035b210086$export$db8f131360c543a5;
};
$eb09df035b210086$export$db8f131360c543a5.walkTokens = function(tokens, callback) {
    return $eb09df035b210086$var$markedInstance.walkTokens(tokens, callback);
};
$eb09df035b210086$export$db8f131360c543a5.parseInline = $eb09df035b210086$var$markedInstance.parseInline;
$eb09df035b210086$export$db8f131360c543a5.Parser = $eb09df035b210086$export$7acfa6ed01010e37;
$eb09df035b210086$export$db8f131360c543a5.parser = $eb09df035b210086$export$7acfa6ed01010e37.parse;
$eb09df035b210086$export$db8f131360c543a5.Renderer = $eb09df035b210086$export$88530751e3977073;
$eb09df035b210086$export$db8f131360c543a5.TextRenderer = $eb09df035b210086$export$75ebcd2c8ed5b901;
$eb09df035b210086$export$db8f131360c543a5.Lexer = $eb09df035b210086$export$6168dc8908a6c652;
$eb09df035b210086$export$db8f131360c543a5.lexer = $eb09df035b210086$export$6168dc8908a6c652.lex;
$eb09df035b210086$export$db8f131360c543a5.Tokenizer = $eb09df035b210086$export$55e8b082af4aa63e;
$eb09df035b210086$export$db8f131360c543a5.Hooks = $eb09df035b210086$export$5fbefe39e79899a6;
$eb09df035b210086$export$db8f131360c543a5.parse = $eb09df035b210086$export$db8f131360c543a5;
var $eb09df035b210086$export$41c562ebe57d11e2 = $eb09df035b210086$export$db8f131360c543a5.options;
var $eb09df035b210086$export$add91eafeaeab287 = $eb09df035b210086$export$db8f131360c543a5.setOptions;
var $eb09df035b210086$export$1f96ae73734a86cc = $eb09df035b210086$export$db8f131360c543a5.use;
var $eb09df035b210086$export$3eedd5437d43cb76 = $eb09df035b210086$export$db8f131360c543a5.walkTokens;
var $eb09df035b210086$export$c7679c2b5e355e6f = $eb09df035b210086$export$db8f131360c543a5.parseInline;
var $eb09df035b210086$export$98e6a39c04603d36 = $eb09df035b210086$export$db8f131360c543a5;
var $eb09df035b210086$export$8f49e4af10703ce3 = $eb09df035b210086$export$7acfa6ed01010e37.parse;
var $eb09df035b210086$export$43feed32102720d2 = $eb09df035b210086$export$6168dc8908a6c652.lex;

});


//# sourceMappingURL=appChatControlInit.6ac10334.js.map
